import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrl: './image-cropper.component.css'
})
export class ImageCropperComponent implements OnInit {

  constructor() { }

  @Input('label') label: string = '';
  @Input('accept') accept: string = 'image/*';
  @Input('type') type: string = '';
  @Input('width') width: number = 0;
  @Input('height') height: number = 0;
  @Input('aspect_ratio') aspect_ratio: number = 0;

  @Output() onCrop = new EventEmitter<string>();

  cropImgPreview: string | any = '';
  immagineFile?: File | null;

  resize_width: number = 0;
  resize_height: number = 0

  ngOnInit(): void {
  }

  cropImg(e: ImageCroppedEvent) {
    this.blobToBase64(e.blob!).then(data => {
      this.cropImgPreview = data;
      this.onCrop.emit(this.cropImgPreview.toString());
    })
  }

  blobToBase64(blob: Blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  onFileLoad(file: File | File[] | null) {
    if (!file || Array.isArray(file)) {
      this.immagineFile = null;
      this.onCrop.emit('');
      return;
    }
    this.immagineFile = file;
  }

}
